// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".monitoring-nav-wrapper[data-v-2c472cfb] {\n  width: 250px;\n}\n.monitoring-nav-item[data-v-2c472cfb] {\n  border: 1px solid #e8eef1;\n  border-radius: 8px;\n}\n.monitoring-nav-item.selected[data-v-2c472cfb] {\n  background: #e8eef1;\n  color: #424f62;\n  font-weight: 700;\n}", ""]);
// Exports
module.exports = exports;
